import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

import type { LeadList } from "../types";

async function getLeadList(
  workspaceId: string,
  listId: string,
): Promise<LeadList> {
  return (await get(`workspaces/${workspaceId}/lists/${listId}`)).list;
}

export default function useLeadList({
  listId,
  placeholderList,
}: {
  listId: string;
  placeholderList: LeadList;
}) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { listsKeys } = getQueryKeys(workspaceId);

  const {
    data: leadList,
    isLoading: isLoadingLeadList,
    refetch: refetchLeadList,
    error: leadListError,
  } = useQuery({
    queryKey: listsKeys.details(listId),
    queryFn: () => getLeadList(workspaceId, listId),
    enabled: !!listId,
    placeholderData: placeholderList,
  });

  return {
    leadList,
    isLoadingLeadList,
    refetchLeadList,
    leadListError,
  };
}
